/**
 * Component to render eligibility criteria tab data in EE how to nominate page
 */
const EligibilityCriteria = (): React.ReactElement => {
  return (
    <div data-testid="eligibility-criteria-component">
      <p>
        The application form must be accompanied by financial statements for the
        last two financial years† and the business must fulfil the following
        criteria:
      </p>

      <div className="mb-5 bg-gray-150 p-4 font-medium">
        <p className="mb-0 font-bold">Years of business operation:</p>

        <p>
          - (For Emerging Enterprise Award and Emerging Enterprise
          Sustainability Award) Up to 10 years
          <br />- (For Most Promising Startup Award and Most Promising
          Sustainability Startup Award) Up to 5 years
        </p>

        <p>
          <span className="mb-0 font-bold">Business incorporation: </span>
          Registered either as a Sole Proprietor, Partnership, Limited
          Partnership, Limited Liability Partnership, or Private Limited. Not
          applicable to (1) a lending institution or an affiliate of such
          lending institution, (2) a listed company or (3) a company which has
          submitted an application for its shares to be listed for quotation on
          the official list of a securities exchange as defined in the
          Securities and Futures Act 2001 on or before the physical presentation
          of the Emerging Enterprise Award or the Emerging Enterprise
          Sustainability Award or the Most Promising Startup Award or the Most
          Promising Sustainability Startup Award at an event organised by the
          organisers/sponsors. Note: For applicants from Indonesia, your
          business must be registered either as a Limited Liability Company
          (Perseroan Terbatas or PT) or Limited Liability Partnership
          (Commanditaire Vennonntschap or CV)
        </p>

        <p>
          <span className="mb-0 font-bold">
            Annual sales turnover as of the last financial year:{" "}
          </span>
          Up to SGD 20 million or local currency equivalent
        </p>

        <p className="mb-0 font-bold">Business profile</p>

        <p className="font-bold">
          Have a business profile that is filed with your country’s official
          regulator of business entities, examples:
        </p>

        <ul className="mb-4 list-outside list-disc pl-8">
          <li>
            Singapore: Business profile with Accounting and Corporate Regulatory
            Authority (ACRA)
          </li>

          <li>
            Malaysia: Business profile with Companies Commission of Malaysia
            (CCM) or Suruhanjaya Syarikat Malaysia (SSM)
          </li>

          <li>
            Indonesia: Company Registration Certificate (TDP) or NIB or Trading
            Business License (SIUP) or similar document
          </li>

          <li>
            Hong Kong: Certificate of Incorporation or Business Registration
            Certificate
          </li>
        </ul>

        <p>
          <span className="mb-0 font-bold">Financial documentation: </span>
          Latest financial statements for the last two financial years,
          including management statements.
        </p>

        <p className="mt-18">
          †For businesses that have only 1 year of operation, financial
          statements can be for the prior or current year, whichever is
          available.
        </p>
      </div>
    </div>
  );
};

export default EligibilityCriteria;
